﻿

	 import { Moment } from 'moment';
    
    export class GPhoneAutoCheckInDTO {
        
        
        name: string;
        
        email: string;
        
        roomNumber: string;
        
        checkout: Moment;
        
        country: string;
        
        lang: string;
    }
